/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: rating-overlay-search-view-component.ts
 *
 * Created by kyang on 1/7/2021.
 */

function RatingOverlaySearchViewController(
    this: JS5Object,
    _: JS5Object,
    $q: JS5Object,
    $routeParams: JS5Object,
    PermissionsService: JS5Object,
    BrandingAssetService: JS5Object,
    BrandingViewService: JS5Object,
) {

    //=========//
    // Toolbar //
    //=========//

    this.hideEmpty = false;
    this.toolbarCheckboxDefs = [
        {
            label: 'Hide Empty',
            onUpdate: (newValue: boolean) => {
                this.hideEmpty = newValue;
            },
            isChecked: this.hideEmpty,
        }
    ];


    //======//
    // Data //
    //======//

    const getBrandingConfig = () => {
        return {
            parentLocation: `${this.baseUrl}/edit/${$routeParams.id}`,
            id: $routeParams.id,
            type: 'ratingOverlays',
            isShow: this.groupName !== 'networks',
            groupName: this.groupName,
        };
    };

    const getData = () => {
        this.loadingIndicator.show = true;
        $q.all({
            container: BrandingAssetService.getBrandingAssetContainer(this.brandingConfig),
            mediaAcceptProfiles: BrandingViewService.getMediaAcceptProfiles(),
        })
            .then((data: JS5Object) => {
                if (this.canReadOverlays) {
                    this.container = data.container;
                    this.mediaAcceptProfiles = data.mediaAcceptProfiles;
                }
            })
            .finally(() => {
                this.loadingIndicator.show = false;
            });
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        this.brandingConfig = getBrandingConfig();

        this.loadingIndicator.show = true;
        PermissionsService.getReadWritePermissions(this.permissionViewState)
            .then((permissions: JS5Object) => {
                this.canReadOverlays = permissions.read;
                return getData();
            });
    };
}

angular.module('prism-ui.components.branding').component('ratingOverlaySearchView', {
    templateUrl: 'components/branding/ratingOverlaySearchView/rating-overlay-search-view-template.html',
    controller: RatingOverlaySearchViewController,
    bindings: {
        isAdmin: '<',
        permissionViewState: '<',
        groupName: '<',
        baseUrl: '<',
    }
});
